import type { CropCenterKeyframe } from '@/hooks/use-auto-save-crop-keyframes';

/** Copy one scene's crop position and zoom onto every keyframe. Time ranges
 *  stay with the scene they already cover. */
export function applyCropFramingToAll(
  keyframes: CropCenterKeyframe[],
  framing: Pick<CropCenterKeyframe, 'x' | 'y' | 'zoom'>,
): CropCenterKeyframe[] {
  return keyframes.map((keyframe) => ({
    ...keyframe,
    x: framing.x,
    y: framing.y,
    zoom: framing.zoom,
  }));
}
